/// <amd-module name="TFS/TeamProfilePanel/TeamProfilePanelFavoriteButton" />
import { FavoriteCreateParameters } from "Favorites/Common/Contracts/Favorite";
import { IFavoritesService } from "Favorites/Common/FavoritesService";
import { FavoritesStar } from "Favorites/Star/FavoritesStar";
import * as React from "react";
import { getTFSPageData, IProjectData } from "Tfs/Platform/Page";
import { useComponentContext } from "VSS/Platform/Layout";
import { ITeamPanelItemView } from "./Models";
import { Types } from "./TeamProfilePanelConstants";

export interface ITeamProfilePanelFavoriteButtonProps {
    className?: string;
    itemView: ITeamPanelItemView;
}
export function TeamProfilePanelFavoriteButton(props: ITeamProfilePanelFavoriteButtonProps): JSX.Element | null {
    const { pageContext } = useComponentContext();
    
    const item = props.itemView.item;
    const favoritesService: IFavoritesService = pageContext.getService<IFavoritesService>("IFavoritesService");
    const projectData: IProjectData | undefined = getTFSPageData(pageContext)?.project;
    const type = getArtifactType(props.itemView.hub);

    if (!favoritesService.canUseFavorites() || !projectData || !item || !type) {
        return null;
    }

    const favorite = {
        artifactId: item.artifactId,
        artifactName: item.name,
        artifactType: type,
        artifactScope: {
            id: projectData.id,
            name: projectData.name,
            type: Types.FavoriteArtifactScopeType
        }
    } as FavoriteCreateParameters;

    return <FavoritesStar artifact={favorite} className={props.className} />;

    function getArtifactType(hub: string): string | undefined {
        let type: string | undefined = undefined;
        switch (hub) {
            case Types.Backlogs:
                type = Types.BacklogsType;
                break;
            case Types.Boards:
                type = Types.BoardsType;
                break;
            case Types.Dashboards:
                type = Types.DashboardType;
                break;
            case Types.Sprints:
                type = Types.SprintsType;
                break;
            case Types.Queries:
                type = Types.QueriesType;
                break;
        }
        return type;
    }
}
